import { render, staticRenderFns } from "./MotDePassePerdu.vue?vue&type=template&id=515a9f52&"
import script from "./MotDePassePerdu.vue?vue&type=script&lang=js&"
export * from "./MotDePassePerdu.vue?vue&type=script&lang=js&"
import style0 from "./MotDePassePerdu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports